import { db } from '../db';
import { loadAppState } from '../stores/appState.svelte.ts';
import { loadChildren } from '../stores/children.svelte.ts';

interface BackupData {
  version: 2;
  timestamp: number;
  sessions: any[];
  storageEntries: any[];
  diapers: any[];
  weights: any[];
  reminders: any[];
  children: any[];
  settings: any[];
  appState: any[];
  activeTimer: any[];
}

export async function createBackup(): Promise<Blob> {
  const data: BackupData = {
    version: 2,
    timestamp: Date.now(),
    sessions: await db.sessions.toArray(),
    storageEntries: await db.storageEntries.toArray(),
    diapers: await db.diapers.toArray(),
    weights: await db.weights.toArray(),
    reminders: await db.reminders.toArray(),
    children: await db.children.toArray(),
    settings: await db.settings.toArray(),
    appState: await db.appState.toArray(),
    activeTimer: await db.activeTimer.toArray(),
  };
  return new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
}

export async function restoreBackup(json: string): Promise<void> {
  const data = JSON.parse(json);
  if (!data.version || !data.timestamp) {
    throw new Error('Invalid backup file');
  }
  if (data.version !== 2) {
    throw new Error('Unsupported backup version. Expected v2.');
  }

  await db.sessions.clear();
  await db.storageEntries.clear();
  await db.diapers.clear();
  await db.weights.clear();
  await db.reminders.clear();
  await db.children.clear();
  await db.settings.clear();
  await db.appState.clear();
  await db.activeTimer.clear();

  if (data.sessions?.length) await db.sessions.bulkAdd(data.sessions);
  if (data.storageEntries?.length) await db.storageEntries.bulkAdd(data.storageEntries);
  if (data.diapers?.length) await db.diapers.bulkAdd(data.diapers);
  if (data.weights?.length) await db.weights.bulkAdd(data.weights);
  if (data.reminders?.length) await db.reminders.bulkAdd(data.reminders);
  if (data.children?.length) await db.children.bulkAdd(data.children);
  if (data.settings?.length) await db.settings.bulkAdd(data.settings);
  if (data.appState?.length) await db.appState.bulkAdd(data.appState);
  if (data.activeTimer?.length) await db.activeTimer.bulkAdd(data.activeTimer);

  await Promise.all([loadChildren(), loadAppState()]);
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
